<template>
    <div>
        <div>xpath <b-button variant="link" @click="add()"><i class="fas fa-plus"></i></b-button></div>

        <draggable :group="'scraping_xpath'" :list="xpath" class="list-group" handle=".handle">
            <b-card v-for="(elem, idx) in xpath" :key="idx">
                
                <b-container style="margin: 0px !important;padding: 0px !important;max-width: none !important;">
                    <b-row>
                        <b-col :cols="2">
                            Nom
                            <b-input v-model="elem.name"></b-input>
                        </b-col>
                        <b-col :cols="5"> 
                            Xpath
                            <b-input v-model="elem.xpath" />
                        </b-col>
                        <b-col :cols="1">
                            Unique
                            <b-checkbox v-model="elem.unique" />
                        </b-col>
                        <b-col :cols="2">                
                            <b-button v-if="!elem.child" variant="link" @click="elem.child = []"><b-button variant="link" @click="add()"><i class="fas fa-plus"></i></b-button>                            enfants</b-button>
                        </b-col>
                        <b-col :cols="2">    
                            <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                            <b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
                        </b-col>
                    </b-row>
                </b-container>
                <div v-if="elem.child">
                    Enfants
                    <scraping_xpath style="margin-left:30px" :ref="'child-' + idx" />
                </div>
            </b-card>
        </draggable>

    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";

	import library from "../../services/library.js";

    var clone = require("clone");
    
    export default {
        name: "scraping_xpath",
		components: {
            draggable
		},
		props: {
            root: {
                default: false
            }
        },
        watch: 
        {
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),

                xpath: []
			};
        },
        methods: {
            get_data()
            {
                return this.save()
            },
            save()
            {
                var xpath = {};
                for (var i = 0; i < this.xpath.length; i++)
                {
                    if (this.xpath[i].child)
                        this.xpath[i].child = this.$refs['child-' + i][0].save();
                    xpath[this.xpath[i].name] = this.xpath[i];
                }

                return xpath;
            },
            async load(data)
            {
                var self = this;
                
                if (!data)
                {
                    return;
                }

                var xpath = [];

                var keys = Object.keys(data);
                for (var i = 0; i < keys.length; i++)
                {
                    data[keys[i]].name = keys[i];
                    xpath.push(data[keys[i]])
                }
                this.xpath = xpath;

                await this.$nextTick();

                console.log("this.xpath")
                console.log(this.xpath)

                for (var i = 0; i < this.xpath.length; i++)
                {
                    if (this.xpath[i].child)
                        await this.$refs['child-' + i][0].load(this.xpath[i].child);
                }
            },
            add()
            {
                this.xpath.push({
                    name: "",
                    xpath: "",
                    unique: false,
                    child: null
                });
            },
            del(idx)
            {
                this.xpath.splice(idx, 1);
            }
        },
        async mounted()
        {		
        }
    }
</script>

<style scoped>
</style>